import { updateArtist } from '@disco/state-management/actions/artist-actions'
import { getArtist } from '@disco/state-management/selectors/artists'

import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useLocation, useParams, useNavigate, Outlet } from 'react-router-dom'
import type { Artist, ArtistId } from 'types/artist'
import type { State } from 'types/redux'
import ArtistProfile from 'components/modals/artist/profile'

export default (): React.ReactNode => {
  const location = useLocation()
  const params = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const artistId: ArtistId = parseInt(params.artistId, 10)
  const artist: Artist = useSelector((state: State) =>
    getArtist(state, artistId),
  )
  const handleCancel = useCallback(() => {
    const returnTo = '/'
    navigate(location.state?.returnTo ?? returnTo)
  }, [navigate, location])

  const handleSubmit = (data: Partial<Artist>) => {
    return dispatch(updateArtist(artistId, data))
  }

  return (
    <>
      {artist && (
        <ArtistProfile
          artist={artist}
          onCancel={handleCancel}
          onSubmit={handleSubmit}
        />
      )}
      <Outlet />
    </>
  )
}
